import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import i18next from "i18next";
import CircleIcon from "mdi-material-ui/CheckboxBlankCircle";

const useStyles = makeStyles((theme) => ({
  isVisible: {
    color: theme.palette.colors.forestGreen300,
    fontSize: theme.typography.fontSize * 1.25,
    marginRight: theme.spacing(1)
  },
  isHidden: {
    color: theme.palette.colors.black40,
    fontSize: theme.typography.fontSize * 1.25,
    marginRight: theme.spacing(1)
  }
}));

/**
 * @name VisibilityCell
 * @param {Object} row A react-table row object
 * @return {React.Component} A date component
 */
export default function VisibilityCell({ row }) {
  const classes = useStyles();

  const { original: { isVisible } } = row;

  if (isVisible) {
    return (
      <div style={{ display: "flex" }}>
        <CircleIcon className={classes.isVisible}/>
        <span>{i18next.t("admin.tags.visible")}</span>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <CircleIcon className={classes.isHidden}/>
      <span>{i18next.t("admin.tags.hidden")}</span>
    </div>
  );
}

VisibilityCell.propTypes = {
  row: PropTypes.object.isRequired
};
